import {actionTypes} from "./actionTypes";

export const toggleWinMessageCreateModal=()=>{
    return {
        type:actionTypes.TOGGLE_CREATE_WIN_MESSAGE_MODAL,
    }
}